/*
 * @Author: zhushitao
 * @Date: 2021-07-06 20:36:24
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-08-02 10:58:58
 * @Description:
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SpectatorCallback = (...props: unknown[]) => any;

export class Spectator {
  private enventMap: Map<string, SpectatorCallback[]> = new Map();

  /**
   * @description 注册
   * @param eventName 事件名称
   * @param callback 回调函数
   */
  public subscribe(eventName: string, callback: SpectatorCallback): void {
    const handlers = this.enventMap.get(eventName);
    if (handlers) {
      handlers.push(callback);
      this.enventMap.set(eventName, handlers);
    } else {
      this.enventMap.set(eventName, [callback]);
    }
  }

  /**
   * @description 清空事件
   * @param eventName  事件 = 插件 | 生命周期
   */
  public unsubscribe(eventName: string): void {
    this.enventMap.delete(eventName);
  }

  /**
   * @description 发布
   * @param eventName 事件 = 插件 | 生命周期
   * @param ctx  appCtx 传入ctx的上下文
   */
  public async publish(eventName: string, ...props: any): Promise<void> {
    const handlers = this.enventMap.get(eventName);

    try {
      if (handlers) {
        const promiseFuncList = handlers?.map(handler =>
          handler.call(this, ...props),
        );
        await Promise.all(promiseFuncList);
      }
    } catch (error) {
      throw error;
    }
  }
  public destroy(): void {
    this.enventMap.clear();
  }
}
